import { DragBar } from './DragBar'

export default DragBar
